import {
    ClickEvent, DataSourceExecutionEvent, DataSourceMode, Layout, OpenType, TableRow, ValidationResult
} from "@mcleod/components";
import { AutogenLayoutCarrierFuelSurchargeList } from "./autogen/AutogenLayoutCarrierFuelSurchargeList";
import { FuelSurchargeOptionsSlideout } from "@mcleod/ar/src/FuelSurchargeOptionsSlideout";
import { FuelSurchargeRowDecorator } from "@mcleod/ar/src/FuelSurchargeRowDecorator";
import { ModelRow, UrlUtil } from "@mcleod/core";
import { ValidationUtil } from "@mcleod/components/src/databinding/ValidationUtil";

export class CarrierFuelSurchargeList extends AutogenLayoutCarrierFuelSurchargeList {

    onLoad(): void | Promise<void> {
        this.tableSurcharges.overrideUrlParams = (selectedRow: TableRow) => {
            return {
                key: selectedRow.data.get("id"),
                surcharge_type: "R"
            };
        }
    }

    sourceCustomerFuelOptionsBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.surcharge_type = 'R';
    }

    async buttonAddSurchargeOnClick(event: ClickEvent) {
        const startingData: ModelRow = await this.tableSurcharges._createNewRowData();
        startingData.set("surcharge_type", 'R');
        const layout = Layout.getLayout(this.tableSurcharges.editLayout) as FuelSurchargeOptionsSlideout;
        const fsrd = new FuelSurchargeRowDecorator({
            layout: layout,
            title: "Add Carrier Fuel Surcharge",
            layoutLoadListeners: () => layout.configureLayoutForSurchargeType('R'),
            width: this.tableSurcharges.editLayoutWidth,
            overlayProps: { closeOnClickOff: false, greyedBackground: true },
            data: startingData,
            dataSourceMode: DataSourceMode.ADD,
            onDelete: null,
            onValidate: () => {
                return this.validateCharge(layout);
            },
            onSave: (updatedData: ModelRow | any) =>
                updatedData.post().then(() =>
                    this.tableSurcharges.dataSource.addRow(updatedData, this.sourceCustomerFuelOptions.data.length)
                )

        });
    }

    sourceCustomerFuelOptionsAfterExecution(event: DataSourceExecutionEvent) {
        const props = UrlUtil.getPropsFromUrl(window.location.search);
        const autoSelectId = props?.surcharge_id;
        if (autoSelectId) {
            const targetRow = this.tableSurcharges.rows.find(row =>
                row.data.get("fuel_surcharge_pay_id") == autoSelectId
            );
            if (targetRow) {
                this.showEditLayout(targetRow);
            }
        }
    }

    private validateCharge(layout: FuelSurchargeOptionsSlideout) {
        const validationResults: ValidationResult[] = layout.validate(true, true);
        const customValidation: ValidationResult = layout.customValidation();
        if (customValidation) {
            validationResults.push(customValidation);
        }
        if (!ValidationUtil.checkValidationResults(validationResults)) {
            ValidationUtil.showFailedValidationDialog(validationResults.filter(result => !result.isValid), validationResults.find(result => !result.isValid)?.validationMessage);
        }
        return validationResults;
    }

    showEditLayout(tableRow: TableRow) {
        this.tableSurcharges.selectedRow = tableRow;
        this.tableSurcharges.crudManager.showDetail(OpenType.SAME_TAB);
    }
}
